// §concierge-add-on — offer Dr. Mavroson's Concierge Weight Management
// membership as an upsell at checkout on the medication flows (compound and
// branded weight loss, TRT, metabolic/sermorelin). Separate from the standalone
// Advanced Weight Loss Support intake (/advanced-weight-loss, $149/mo): this is
// the practice's concierge tier bundled with a treatment order, at the owner's
// add-on price.
//
// Owner pricing, 2026-10-07:   $149 / month, first month charged with the order.
//
// Copy and imagery come from the practice's own product page
// (doctorskinnyshot.com/products/concierge-weight-management-program).
//
// CENTS, like everything else priced in this app.
//
// FULFILMENT IS A BACKEND HANDOFF (docs/BACKEND_CONCIERGE_WL_ADDON_PRD.md): the
// FE charges the first month inside the treatment payment and sends
// `conciergeAddOn` with the visit; the backend creates the monthly subscription
// on the card on file and routes the patient to Dr. Mavroson. Until that ships
// the flag below stays OFF in production.
import { isStateServed } from './conciergeCommon';

export const isConciergeAddOnEnabled = () =>
  process.env.REACT_APP_CONCIERGE_ADDON_ENABLED === '1';

export const CONCIERGE_PRICE_LIST_DATE = '2026-10-07';

export const CONCIERGE_WL_ADDON = {
  program: 'advancedWeightLoss',
  planId: 'concierge-weight-loss-149',
  name: 'Concierge Weight Management',
  doctor: 'Dr. Matt Mavroson, DO',
  practice: 'Mavroson Medical, P.C. · Dr. SkinnyShot',
  monthlyCents: 14900,
  firstMonthCents: 14900,
  // The practice's public price for the same membership, for the strike-through.
  publicMonthlyCents: 10000,
  heroImage: '/programs/concierge-weight-management-hero.jpg',
  doctorImage: '/programs/team/matthew-mavroson-cover.jpg',
  includes: [
    'Direct cell phone access to Dr. Mavroson for texts or calls',
    'Personalized weight-management planning and ongoing clinical follow-up',
    'Member pricing on advanced hormone testing',
    'Member pricing on GI-Mapping, biological-age (epigenetics) and microplastics testing',
    'Preferred pricing on full-body MRI services',
  ],
  footnote: 'Membership covers clinical oversight and consultations. Prescribed medications are fulfilled and billed separately. Offered in New York.',
  quote: 'Modern medicine shouldn’t feel like a maze. We review your individual health profile to ensure your treatment plan is safely tailored to your body and long-term vitality goals.',
};

/**
 * Whether the upsell page should be shown at all: feature on AND the patient
 * is in a state the practice serves (same gate as the concierge intakes).
 * State is read from the shipping address first, then the residence answer.
 */
export function conciergeAddOnAvailable(answers = {}) {
  if (!isConciergeAddOnEnabled()) return false;
  const addr = answers['shipping-address'] || answers.shippingAddress || answers.address || {};
  const state = addr.state || answers['state-of-residence'] || answers.state || '';
  return !!state && isStateServed(state);
}

/** What the add-on contributes to today's charge; 0 when not selected or off. */
export function conciergeAddOnCents(selected) {
  if (!selected || !isConciergeAddOnEnabled()) return 0;
  return CONCIERGE_WL_ADDON.firstMonthCents;
}

/** Submit payload; null when nothing was added so the field is absent. */
export function conciergeAddOnPayload(selected) {
  if (!selected || !isConciergeAddOnEnabled()) return null;
  return {
    program: CONCIERGE_WL_ADDON.program,
    planId: CONCIERGE_WL_ADDON.planId,
    monthlyCents: CONCIERGE_WL_ADDON.monthlyCents,
    firstMonthCents: CONCIERGE_WL_ADDON.firstMonthCents,
    priceListDate: CONCIERGE_PRICE_LIST_DATE,
  };
}
